import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

import ManualBackupForm from './ManualBackupForm';
import ScheduledBackupForm from './ScheduledBackupForm';
import Modal from '../../sections/modal/Modal';

const CreateBackupButtons = (props) => {
  const { t } = useTranslation();

  const [openRegularBackupModal, setOpenRegularBackupModal] = useState(false);
  const [openManualBackupModal, setOpenManualBackupModal] = useState(false);

  const handleRegularBackupOpen = () => setOpenRegularBackupModal(true);
  const handleRegularBackupClose = () => setOpenRegularBackupModal(false);

  const handleManualBackupOpen = () => setOpenManualBackupModal(true);
  const handleManualBackupClose = () => setOpenManualBackupModal(false);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          startIcon={<AddIcon />}
          sx={{ mr: 2 }}
          onClick={handleRegularBackupOpen}
        >
          {t('add', {
            ns: 'buttons',
            text: t('backup.scheduled', { ns: 'project' }),
          })}
        </Button>
        <Button onClick={handleManualBackupOpen}>
          {t('take', {
            ns: 'buttons',
            text: t('backup.manual', { ns: 'project' }),
          })}
        </Button>
      </Box>

      <Modal
        openModal={openRegularBackupModal}
        title={t('backup.scheduled', { ns: 'project' })}
        handleClose={handleRegularBackupClose}
      >
        <ScheduledBackupForm
          {...props}
          handleModalClose={handleRegularBackupClose}
        />
      </Modal>

      <Modal
        openModal={openManualBackupModal}
        title={t('backup.manual', { ns: 'project' })}
        handleClose={handleManualBackupClose}
      >
        <ManualBackupForm
          {...props}
          handleModalClose={handleManualBackupClose}
        />
      </Modal>
    </>
  );
};

export default CreateBackupButtons;
